/* istanbul ignore file */

import URI from "urijs";

import { MapStringTo } from "../base-types";
import { HttpMethod } from "../http-method";

/**
 * A request message to be used with {@link IInternalClient} implementations.
 */
export class RequestMessage<T = any> {
    /**
     * HTTP method that indicates the desired action to be performed.
     */
    method: HttpMethod;

    /**
     * A URI referring to a resource on the Web.
     */
    requestUri: URI | string;

    /**
     * Headers with additional information that will be sent to the server.
     */
    requestHeaders?: MapStringTo<string>;

    /**
     * The content (or body) of the message that will be sent to the server.
     */
    content?: T;

    constructor(init?: RequestMessage) {
        Object.assign(this, init);
    }
}
